import Card from '@/ui/card/defaultCard/Card';
import ESGRiskInsights from './components/ESGRiskInsights/ESGRiskInsights';

interface ESG_Stock_MarketTrendProps {
  data?: any;
  category?: any;
  handler?: any;
  addFollowing?: any;
  cancelFollowing?: any;
  followingList?: any;
  isLoading?: any;
}

const ESG_Stock_MarketTrend = ({
  data,
  category,
  handler,
  addFollowing,
  cancelFollowing,
  followingList,
  isLoading,
}: ESG_Stock_MarketTrendProps) => {
  return (
    <Card>
      <ESGRiskInsights
        data={data?.esgMarketData}
        handler={handler}
        category={category?.marketTrendCategory}
        addFollowing={addFollowing}
        cancelFollowing={cancelFollowing}
        followingList={followingList}
        isLoading={isLoading?.isLoading_esgMarket}
      />
    </Card>
  );
};

export default ESG_Stock_MarketTrend;
